<template>
<div class="parking_box">
  <template v-if="showPage">
    <!-- 停车场信息 -->
    <parking-message :parkingMess="parkingMess" :applyData="applyData"></parking-message>
    <!-- 套餐类型 -->
    <package-select :parkingMess="parkingMess" @packageChange="packageChange" :dayNightType="dayNightType" :ParkFeeId="ParkFeeId" :ParkFeeSelectItem="ParkFeeSelectItem" ></package-select>

    <!-- <package-select :parkingMess="parkingMess" :dayNightType="dayNightType" @packageChange="packageChange"></package-select> -->
    <!-- 填写申请信息 -->
    <apply-message come="repeat" :name="userName" @inputChange="inputChange" :maxEndDay="maxEndDay" :applyData="applyData" :parkingMess="parkingMess"></apply-message>
    <!-- 车牌号   -->
    <card-number @inputChange="inputChange" come="repeat" :showUpLoadImg="true" :repeatCardList="cardList" :oldTarget="oldTarget"></card-number>
    <section class="footer_h"></section>
    <common-footer text="立即申请" :canClick="canClick" @btnClick="btnClick"></common-footer>
  </template>
</div>
</template>

<script>
import ParkingMessage from './components/parkingMessage';
import PackageSelect from './components/packageSelect';
import ApplyMessage from './components/applyMessage';
import CardNumber from './components/cardNumber';
import CommonFooter from '../../components/footer';
import util from '../../utils/util';
import storage from '../../utils/storage';
import {loadParkHeaderById,queryBpmFlowByBuildIds,startInstance,spaceUpPcHttp} from '../../utils/api';
import {mapState} from 'vuex';
export default {
  name: 'parking',
  props: {},
  components: {
    PackageSelect,
    ApplyMessage,
    CardNumber,
    CommonFooter,
    ParkingMessage
  },
  filters: {
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  data() {
    return {
      ParkFeeId:'',
      ParkFeeSelectItem:'',
      changeTargetIdUrl:spaceUpPcHttp+'/syscfg/attachmentTerminal/bindSomeAttachments',
      searchFileUrl:spaceUpPcHttp+'/syscfg/attachmentTerminal/queryAttachmentListByOneData',
      approvalProcessTime:0,//发起流程次数
      startInstanceTime:0,//发起审批次数
      canClick:false,
      tips:false,
      applyMess:false,
      parkingMess:{},
      userName:'',
      applyData:{},
      cardList:[],//车牌数据
      showPage:false,
      applyUser:'',
      startTime:'',
      endTime:'',
      applyStartDay:'',
      applyEndDay:'',
      timemap:'',
      hex_md5_return:'',
      dayNightType:1,
      maxEndDay:9640880000000,//有价格区间的最大日期
      oldTarget:new Date().getTime()
    }
  },
  created() {
    // 获取停车场信息
    this.loadParkHeaderById()
    this.loadParkLot()
  },
  activated(){
    if(storage.getS("ParkFeeSelectItem")){
      this.ParkFeeSelectItem =  JSON.parse(storage.getS("ParkFeeSelectItem"));
      storage.removeS('ParkFeeSelectItem');
    }
  },
  mounted(){

  },
  methods: {
     packageChange(item){
      if(item){
        this.ParkFeeId = item.id;
        this.dayNightType = item.dayNightType
        this.maxEndDay = item.maxEndDay
      }
    },
    inputChange(val){
      if(val.type == 'name'){
        this.userName = val.val;
      }else if(val.type == 'time'){
        this.applyStartDay = val.val.startTime
        this.applyEndDay = val.val.endTime
      }else if(val.type == 'card'){
        let cardList = val.data || [];
        this.cardList = cardList;
        console.log(this.cardList)
        let plateNo = []
        cardList.forEach(item=>{
          plateNo.push(item.cardNumber)
        })
        this.plateNo = plateNo.join(",")
      }
      if(!this.userName || !this.applyStartDay || !this.applyEndDay){
        this.canClick = false
      }else{
        this.canClick = true
      }
    },
    // 获取车场数据
    loadParkHeaderById(){
      util.showLoading();
      let params = {
        id:this.$route.query.parkId,
        url:"/parking/rstParkHeader/loadParkHeaderById"
      }
      loadParkHeaderById(params).then(res=>{
        util.hideLoading()
        console.log(res)
        if(res.res && res.res.code === 10000 && res.body){
          this.parkingMess = res.body.data
          if(res.body.data.prkParkFeeBeanList && res.body.data.prkParkFeeBeanList.length > 0){
            let newL = res.body.data.prkParkFeeBeanList.filter(item=>{return item.parkType == 4})
            this.prkParkFeeBeanList = newL;
            this.ParkFeeId = newL[0].id;
            this.dayNightType = newL[0].dayNightType;//设置默认选中套餐
            this.maxEndDay = newL[0].maxEndDay;//价格区间最大日期
            if(newL.length == 0){
              util.showModal('','该项目停车场尚未配置停车月租优惠',false,'我知道了',()=>{
                this.$router.go(-1)
              })
            }
          }
        } else {
          util.showToast(res.res.msg)
        }
      })
    },
    // 获取用户申请信息
    loadParkLot(){
      util.showLoading()
      let params = {
        userId:this.common.userId,
        phone:this.common.userInfo.account || this.common.userInfo.phone,
        parkHeaderId:this.$route.query.parkId,
        url:"/parking/rstParkLot/loadParkLot"
      }
      loadParkHeaderById(params).then(res=>{
        util.hideLoading()
        console.log(res)
        if(res.res && res.res.code === 10000 && res.body && res.body.data){
          this.applyData =  res.body.data;
          this.dayNightType = this.applyData.dayNightType;
          this.userName = this.applyData.userName;
          this.ParkFeeId = this.applyData.id;
          let plateNo = [];
          let cardList = this.applyData.prkParkLotPlateBeans || [];
          cardList.forEach((item,index)=>{
            this.changeTarget(item.id,this.oldTarget+index*100,1,item.plateNo);
              plateNo.push(item.plateNo)
          })
          this.plateNo = plateNo.join(",")
        }
        this.showPage = true;
      })
    },
    btnClick(){
      if(new Date(this.applyStartDay.replace(/-/g,"/")+' 00:00:00').getTime()-new Date(this.applyEndDay.replace(/-/g,"/")+' 23:59:59').getTime()>0){
        util.showToast('结束时间应该大于开始时间',2000)
        return false;
      }
      let applyMinUnit = this.parkingMess.applyMinUnit;//最小起租单位（1天 2月）
      let applyMaxCount = this.parkingMess.applyMaxCount;//最大起租数
      let applyMinCount = this.parkingMess.applyMinCount;//最小起租数
      let applyMaxUnit = this.parkingMess.applyMaxUnit;//最大申请单位（1天 2月）
      let monthType = this.parkingMess.monthType;//1(整月模式 年月),2(非整月 年月日)
      if(monthType == 1){
        let startD = this.applyStartDay.split("-");
        let endD = this.applyEndDay.split("-");
        if((endD[0]-startD[0])*12+Number(endD[1])-Number(startD[1]) < applyMinCount-1){
          util.showToast(`最小起租${applyMinCount}个月`,2000)
          return;
        }
      }else{
        // 最小起租单位为天
        if(applyMinUnit == 1){
          // 结束时间-开始时间 小于 最小起租数
          if(Math.round((new Date(this.applyEndDay.replace(/-/g,"/")+' 23:59:59').getTime()-new Date(this.applyStartDay.replace(/-/g,"/")+' 00:00:00').getTime())/(24*60*60*1000)) < applyMinCount){
            util.showToast(`最小起租${applyMinCount}天`,2000)
            return false;
          }
        }else{
          // 开始时间+n月后的时间-结束时间 大于 结束时间
          let startD = this.applyStartDay.split("-");
          let ys = parseInt((startD[1]- 0 + this.parkingMess.applyMinCount)/12);
          let year = startD[0] + ys;
          let month = startD[1]-0 + this.parkingMess.applyMinCount-ys*12>=10?startD[1]-0 + this.parkingMess.applyMinCount-ys*12:'0'+(startD[1]-0 + this.parkingMess.applyMinCount-ys*12)
          let day = Number(startD[2]) >= 10 ? startD[2]:'0'+startD[2]
          let newSjc = new Date(year+'/'+month+'/'+day+' 00:00:00').getTime()-24*60*60*1000
          if(newSjc > new Date(this.applyEndDay.replace(/-/g,".")+' 23:59:59').getTime()){
            util.showToast(`最小起租${applyMinCount}月`,2000)
            return false;
          }
        }
      }
      if(this.applyStartDay.split('-').length === 2){
        this.applyStartDay = this.applyStartDay + "-01"
        let endt = new Date(this.applyEndDay.split('-')[0],this.applyEndDay.split('-')[1],0);
        let {year,month,day} = util.formatTime(endt,17);
        this.applyEndDay = util.formatTime(new Date(year+'/'+month+'/'+day+' 23:59:59'),9)
      }
      util.showLoading('提交中...')
      this.canClick = false
      let params = {
        "platform": "RST",
        "userId": this.common.userId,
        "userName": this.userName,
        "companyName":"",
        "companyId":"",
        "subProjectId": this.common.marketInfo.id,//项目id
        "phone":this.common.userInfo.account || this.common.userInfo.phone,
        "numberType": 2,//申请类型 2个人月租 3临停优惠
        "parkHeaderId": this.parkingMess.id,//车场id
        "plateNo":this.plateNo,//车牌
        "applyStartDay": this.applyStartDay.replace(/-/g,".")+' 00:00:00',
        "applyEndDay": this.applyEndDay.replace(/-/g,".")+' 23:59:59',
        "dayNightType": this.dayNightType,// 1、全天；2、白天；3夜晚
        "url": "/parking/rstParkLot/applayParkLot"
      }
      if(this.common.userTenantInfo.id){
        params.companyName = this.common.userTenantInfo.company,
        params.companyId = this.common.userTenantInfo.companyId
      }
      loadParkHeaderById(params).then(res=>{
        console.log(res)
        if(res.res.code === 10000 && res.body){
          let prkParkLotPlateBeans = res.body.data.prkParkLotPlateBeans || [];
          // 遍历车牌列表 替换对应的图片
          prkParkLotPlateBeans.forEach(item=>{
            this.cardList.forEach(card=>{
              if(card.cardNumber == item.plateNo){
                if(card.fileList.length > 0){
                  this.changeTarget(card.targetId,item.id)
                }
              }
            })
          })
          // 申请待办
          if(res.body.data.applyStatus ==1){
              this.approvalProcess(res.body.data.pid,res.body.data.bizFlag,res.body.data)
          }else{
            this.$router.go(-1)
            this.canClick = true
            util.hideLoading()
          }
        }else{
          this.canClick = true
          util.hideLoading()
          util.showToast(res.res.msg)
        }
      })
    },
    resetSign(){
      // 公钥+私钥+时间戳+平台
      let gong = 'vanke2019spaceup009'
      let si = '009vanke2019spaceup001'
      this.timemap = new Date().getTime()
      let platfrom = 'SaasMobile'
      let str = gong+si+this.timemap+platfrom
      this.hex_md5_return = this.$md5(str)
    },
    changeTarget(targetId,id,copyNew,plateNo){
      let self = this;
      this.resetSign()
      fetch(self.changeTargetIdUrl, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          "Access-channel": "saas_rst",
          "companyId":self.common.marketInfo.cityId
        },
        body: JSON.stringify({
          'newTarget': id,
          'oldTarget': targetId,
          'bizCode': 'TCP',
          'platform': 'SaasMobile',
          'timestamp': self.timemap,
          'sign':self.hex_md5_return,
          'companyId':self.common.marketInfo.cityId,
          'copyNew':copyNew
        })
      }).then(response => response.json()).then(res => {
        console.log("替换成功")
        console.log(res)
        // 判断是否是复制新的一条数据
        if(copyNew){
          this.getImgs(id,plateNo)
        }
      })
    },
    getImgs(targetId,plateNo){
      fetch(this.searchFileUrl+"?moduleCode=TCP&target="+targetId+"&platform=SaasMobile"+"&timestamp="+this.timemap+"&sign="+this.hex_md5_return+"&companyId="+this.$store.state.common.marketInfo.cityId, {
        method: 'get',
        headers:{
          "Access-channel": "saas_rst"
        },
      }).then(response => response.json()).then(res => {
        console.log(res)
        if(res.code === 1000){
          this.cardList.push({fileList:res.data,targetId:targetId,cardNumber:plateNo})
          console.log(this.cardList)
        }
      })
    },
    // 发起审批流程
    approvalProcess(pid,bizFlag,data){
      let params ={
        companyId:this.common.marketInfo.cityId,
        subProjectIds:this.common.marketInfo.id,
        pid:pid,
        bizFlag:bizFlag
      }
      let headers = {
        "Access-channel": "saas_rst",
        'companyId':this.common.marketInfo.cityId
      }
      queryBpmFlowByBuildIds(params,headers).then(res=>{
        console.log(res)
        if(res.code === 1000 && res.data){
          this.approvalProcessTime = 0;
          storage.setS("isNeedFresh",true)
          this.startInstance(res.data[0],data)
        }else{
          this.approvalProcessTime += 1;
          if(this.approvalProcessTime < 3){
            this.approvalProcess(pid,bizFlag,data)
          }else{
            this.canClick = true
            util.hideLoading()
            util.showToast('提交失败')
          }
        }
      })
    },
    startInstance(msg,data){
      let params = {
        flowPk:msg.id,
        flowId:msg.flowId,
        promoter:data.promoter,//发起人id
        // promoterName:this.userName,//申请人名称
        companyId:this.common.marketInfo.cityId,
        data:JSON.stringify(data),
        param:"",
        subject:"",
        bsid:data.bsid,
        nodeList:msg.nodeList,
        channel:'SAMQI',
        platform:'SAAS',
        timestamp:new Date().getTime(),
        sign:this.$md5('mhxzkhl990' + "SAAS" + (new Date().getTime() + Number(this.common.marketInfo.cityId)) + 'ncbbsss123')
      }
      let headers = {
        "Access-channel": "saas_rst",
        'companyId':this.common.marketInfo.cityId
      }
      if (Object.keys(this.common.userTenantInfo).length > 0) {
          params.promoterName = this.common.userTenantInfo.userName
      } else {
          params.promoterName = this.common.userInfo.userName
      }
      startInstance(params,headers).then(res=>{
        console.log(res)
        this.canClick = true
        if(res.code === 1000){
          this.startInstanceTime = 0;
          util.hideLoading()
          this.$router.go(-1)
        }else{
          this.startInstanceTime += 1;
          if(this.startInstanceTime < 3){
            this.startInstance(msg,data)
          }else{
            util.hideLoading()
            util.showToast('提交失败')
          }
        }
      })
    },
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.parking_box{
  background:#eee;
}
.footer_h{
  height:120px;
}
.hb_height{
  height:76px;
}
.hb_tips{
  position:fixed;
  bottom:108px;
  left:0;right:0;
  .flex();
  justify-content: center;
  align-items: center;
  height:76px;
  background:rgba(254,238,223,1);
  .hint_icon{
    width:28px;
    height:28px;
    margin-right:14px;
  }
  p{
    font-size:26px;
    color:rgba(253,152,56,1);
  }
  .close_icon{
    position: absolute;
    top:16px;right:10px;
    width:44px;height:44px;
  }
}
</style>
